import { MarketingCTA } from '../CTA/MarketingCTA'

type SolutionsCaseStudyCTAProps = {
  header: string
  learnMoreLink?: string
}

const SolutionsCaseStudyCTA = ({ header, learnMoreLink }: SolutionsCaseStudyCTAProps) => {
  return (
    <section className="bg-neutral-muted pt-16 sm:pt-8">
      <MarketingCTA>
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-8 lg:flex-row lg:items-start lg:gap-12">
          {/* Heading - centered vertically with button */}
          <h1 className="text-center font-extralight leading-tight tracking-tight text-text-inverted lg:text-left  lg:leading-tight text-5xl">
            {header}
          </h1>

          {/* Button - aligned to center on mobile, right on desktop */}
          {learnMoreLink && (
            <div className="shrink-0">
              <button
                className="px-4 py-2 text-sm font-semibold text-white no-underline transition-colors rounded bg-brand-blue border-0 cursor-pointer hover:bg-brand-navy"
                onClick={() => window.open(learnMoreLink, '_blank')}
              >
                Learn more
              </button>
            </div>
          )}
        </div>
      </MarketingCTA>
    </section>
  )
}

export default SolutionsCaseStudyCTA
